// 'use client';

// import React from 'react';
// import dynamic from 'next/dynamic';
// import { ChevronDown } from 'lucide-react';
// import type { Variants } from 'motion/react';

// import { Entity, Snippet, SNIPPET_TYPE } from '@repo/types';
// import {
//   Accordion,
//   AccordionContent,
//   AccordionItem,
//   AccordionTrigger,
// } from '@repo/ui/components/ui/accordion';
// import { cn } from '@repo/ui/lib/utils';

// const MotionDiv = dynamic(
//   () => import('motion/react').then((mod) => mod.motion.div),
//   {
//     ssr: false,
//   },
// );

// const bubbleVariants: Variants = {
//   active: {
//     opacity: 1,
//     y: 0,
//     transition: {
//       duration: 0.5,
//     },
//   },
//   inactive: {
//     opacity: 0,
//     y: 10,
//     transition: {
//       duration: 0.5,
//     },
//   },
// };

// enum ACCORDION_TYPE {
//   CHARTS_ACCORDION = 'charts-accordion',
// }

// interface AccordionState {
//   isCollapsed: boolean;
//   expandedAccordions: Set<number>;
// }

// interface TabContentItemProps {
//   entities?: Entity[];
//   snippet: Snippet;
//   index: number;
//   accordionsState: AccordionState;
//   updateAccordionState: (
//     tabType: SNIPPET_TYPE,
//     index: number,
//     isExpanded: boolean,
//   ) => void;
//   tabType: SNIPPET_TYPE;
// }

// export const TabContentItem: React.FC<TabContentItemProps> = ({
//   entities,
//   snippet,
//   index,
//   accordionsState,
//   updateAccordionState,
//   tabType,
// }) => {
//   const isExpanded = accordionsState.expandedAccordions.has(index);
//   const accordionValue = isExpanded ? ACCORDION_TYPE.CHARTS_ACCORDION : '';

//   const handleAccordionClick = () => {
//     const newIsExpanded = !isExpanded;
//     updateAccordionState(tabType, index, newIsExpanded);
//   };

//   const getEntityName = () => {
//     if (
//       !entities ||
//       entities.length === 0 ||
//       !Number.isInteger(snippet.entityId)
//     )
//       return '';

//     return entities?.find((entity) => entity.id === snippet.entityId)?.name;
//   };

//   return (
//     <MotionDiv variants={bubbleVariants} className="group">
//       <Accordion
//         type="single"
//         value={accordionValue}
//         onValueChange={(value) => {
//           const newIsExpanded = value === ACCORDION_TYPE.CHARTS_ACCORDION;
//           updateAccordionState(tabType, index, newIsExpanded);
//         }}
//         collapsible
//         className="w-full"
//       >
//         <AccordionItem
//           value={ACCORDION_TYPE.CHARTS_ACCORDION}
//           className={cn(
//             'w-full flex flex-col items-center border-none bg-[#F5F7FA] pt-1.5 pb-0 px-0 overflow-hidden group-first:rounded-t-[6px] group-last:rounded-b-[6px] @cred-md:pt-[7px] @cred-lg:pt-2 @cred-xl:pt-2.5 space-y-[3px] @cred-md:space-y-[3.5px] @cred-lg:space-y-1 @cred-xl:space-y-[5px]',
//             snippet.type === SNIPPET_TYPE.CLAIMEDFACTS &&
//               'group-even:bg-[#D8FFF2]',
//             snippet.type === SNIPPET_TYPE.OPINIONSTATEMENTS &&
//               'group-even:bg-[#FFFAE0]',
//             snippet.type === SNIPPET_TYPE.DUBIOUSCLAIMS &&
//               'group-even:bg-[#FFE6DE]',
//           )}
//         >
//           <div
//             onClick={handleAccordionClick}
//             className="relative w-full px-[11px] space-y-1.5 @cred-md:space-y-[7px] @cred-lg:space-y-2 @cred-xl:space-y-2.5"
//           >
//             <p className="break-words text-xs font-normal leading-[13px] text-neutral-2 @cred-md:text-sm @cred-md:leading-[15.2px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-lg @cred-xl:leading-[21.7px]">
//               {snippet.text}
//             </p>
//             <div className="flex w-full gap-1 justify-end">
//               {getEntityName() && (
//                 <div className="flex justify-center h-fit items-center px-1.5 py-[3px] rounded-lg bg-[#3E67A8] @cred-md:px-2 @cred-md:py-[3.5px] @cred-lg:px-2 @cred-lg:py-[3.5px] @cred-xl:px-2 @cred-xl:py-[3.5px]">
//                   <p className="line-clamp-1 text-[9px] font-semibold leading-tight text-white @cred-md:text-[10px] @cred-md:leading-[13px] @cred-lg:text-[10px] @cred-lg:leading-[13px] @cred-xl:text-[11px] @cred-xl:leading-[13px]">
//                     {getEntityName()}
//                   </p>
//                 </div>
//               )}
//               <AccordionTrigger
//                 hideIcon
//                 className="flex size-auto text-black justify-center items-center p-[3px] cursor-pointer"
//               >
//                 <ChevronDown
//                   className={cn(
//                     'size-3.5 transition-transform shrink-0 @cred-md:size-[14.5px] @cred-lg:size-[15px] @cred-xl:size-4',
//                     accordionValue === ACCORDION_TYPE.CHARTS_ACCORDION &&
//                       'rotate-180',
//                   )}
//                 />
//               </AccordionTrigger>
//             </div>
//           </div>
//           <AccordionContent
//             style={{ width: '100%' }}
//             className="relative w-full flex items-center justify-start gap-1.5 border-none pr-[11px] pb-1.5 @cred-md:pb-[7px] @cred-lg:pb-2 @cred-xl:pb-2.5 pt-[3px] @cred-md:pt-[3.5px] @cred-lg:pt-1 @cred-xl:pt-[5px]"
//           >
//             <div className="w-[3px] @cred-md:w-[3.5px] @cred-lg:w-1 @cred-xl:w-[5px]">
//               <div
//                 className={cn(
//                   'absolute top-0 bottom-0 left-0 h-full w-[3px] @cred-md:w-[3.5px] @cred-lg:w-1 @cred-xl:w-[5px]',
//                   snippet.type === SNIPPET_TYPE.CLAIMEDFACTS && 'bg-[#00B378]',
//                   snippet.type === SNIPPET_TYPE.OPINIONSTATEMENTS &&
//                     'bg-[#FFCC00]',
//                   snippet.type === SNIPPET_TYPE.DUBIOUSCLAIMS && 'bg-[#EA420F]',
//                 )}
//               />
//             </div>
//             <p className="text-[11px] font-normal leading-[13px] text-neutral-2 @cred-md:text-[13px] @cred-md:leading-[16px] @cred-lg:text-[13px] @cred-xl:text-base @cred-xl:leading-[18px]">
//               <b className="font-bold">Reason: </b>
//               {snippet.reason}
//             </p>
//           </AccordionContent>
//         </AccordionItem>
//       </Accordion>
//     </MotionDiv>
//   );
// };

'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import type { Variants } from 'motion/react';
import posthog from 'posthog-js';

import { Snippet, SNIPPET_TYPE } from '@repo/types';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
} from '@repo/ui/components/ui/accordion';
import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from '@repo/ui/components/ui/tooltip';
import { cn } from '@repo/ui/lib/utils';

import { AnalysisTooltipContent } from '@/components/article-analysis/analysis-container';

const MotionDiv = dynamic(
  () => import('motion/react').then((mod) => mod.motion.div),
  {
    ssr: false,
  },
);

const bubbleVariants: Variants = {
  active: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
  inactive: {
    opacity: 0,
    y: 10,
    transition: {
      duration: 0.5,
    },
  },
};

const getSnippetTextWithQuotes = (text: string) => {
  if (text.includes('“') && text.includes('”')) {
    return text;
  }
  if (text.includes('“') && !text.includes('”')) {
    return `${text}”`;
  }
  if (!text.includes('“') && text.includes('”')) {
    return `“${text}`;
  }
  if (text[0] === '"' && text[text.length - 1] === '"') {
    return `“${text.slice(1, -1)}”`;
  }
  if (text[0] === '"' && text[text.length - 1] !== '"') {
    return `“${text.slice(0, -1)}”`;
  }
  if (text[0] !== '"' && text[text.length - 1] === '"') {
    return `“${text.slice(0, -1)}”`;
  }
  return `“${text}”`;
};

interface AccordionState {
  isCollapsed: boolean;
  expandedAccordions: Set<number>;
}

interface TabContentItemProps {
  snippet: Snippet;
  index: number;
  accordionsState: AccordionState;
  updateAccordionState: (
    tabType: SNIPPET_TYPE,
    index: number,
    isExpanded: boolean,
  ) => void;
  tabType: SNIPPET_TYPE;
}

export const TabContentItem: React.FC<TabContentItemProps> = ({
  snippet,
  index,
  accordionsState,
  updateAccordionState,
  tabType,
}) => {
  const isExpanded = accordionsState.expandedAccordions.has(index);
  const accordionValue = isExpanded ? 'charts-accordion' : '';

  const handleAccordionClick = () => {
    const newIsExpanded = !isExpanded;

    // B7 — per-statement reasoning expansion. Each individual statement
    // categorized as fact/opinion/dubious has a click-to-expand reasoning
    // box. **The dubious-claim expansions are the highest-value
    // engagement signal in the entire product** — they're the user
    // actively engaging with skim's most-controversial output.
    //
    // Why this is a separate event from B6's `reasoning_expanded`:
    //   - B6 fires for the THREE top-level score circles (credibility,
    //     bias, originality, depth) — one per article view
    //   - B7 fires for each individual STATEMENT inside the article —
    //     potentially dozens per article view
    //   - Conflating them would make B6 noise and B7 invisible
    //
    // Properties: tab_type (which category — CLAIMEDFACTS /
    // OPINIONSTATEMENTS / DUBIOUSCLAIMS), statement_index, transition.
    posthog.capture(
      newIsExpanded
        ? 'statement_reasoning_expanded'
        : 'statement_reasoning_collapsed',
      {
        content_type: 'article',
        tab_type: tabType,
        statement_index: index,
        has_source: !!snippet.source,
      },
    );

    updateAccordionState(tabType, index, newIsExpanded);
  };

  return (
    <MotionDiv variants={bubbleVariants} className="group">
      <Accordion
        type="single"
        value={accordionValue}
        onValueChange={(value) => {
          const newIsExpanded = value === 'charts-accordion';
          updateAccordionState(tabType, index, newIsExpanded);
        }}
        collapsible
        className="w-full"
      >
        <AccordionItem
          value="charts-accordion"
          className="w-full flex flex-col items-center border-none"
        >
          <TooltipProvider>
            <Tooltip delayDuration={200}>
              <TooltipTrigger asChild>
                <div
                  onClick={handleAccordionClick}
                  className={cn(
                    "relative w-full space-y-1 rounded-[.8125rem] bg-[#F5F7FA] px-[.6875rem] py-1.5 transition-colors before:absolute before:bottom-[-0.1rem] before:h-4 before:transition-colors before:content-[''] after:absolute after:bottom-[-0.1rem] after:h-4 after:content-[''] hover:bg-[#CCCCCC]",
                    index % 2 === 0
                      ? 'self-end before:right-[-0.35rem] before:translate-y-[-0.1rem] before:rounded-bl-[.8rem_.7rem] before:border-r-[1rem] before:border-r-[#F5F7FA] after:-right-10 after:w-2.5 after:-translate-y-0.5 after:-translate-x-7.5 after:rounded-bl-[.5rem] after:bg-black hover:before:border-r-[#CCCCCC]'
                      : 'self-start before:left-[-0.35rem] before:translate-y-[-0.1rem] before:rounded-br-[.8rem_.7rem] before:border-l-[1rem] before:border-l-[#F5F7FA] after:left-5 after:w-2.5 after:-translate-y-0.5 after:-translate-x-7.5 after:rounded-br-[.5rem] after:bg-black hover:before:border-l-[#CCCCCC]',
                    snippet.type === SNIPPET_TYPE.CLAIMEDFACTS &&
                      'group-odd:bg-[#D8FFF2] group-odd:before:border-r-[#D8FFF2] group-odd:after:border-r-[#D8FFF2] group-odd:hover:bg-[#CCCCCC] group-odd:hover:before:border-r-[#CCCCCC] group-odd:hover:after:border-r-[#CCCCCC]',
                    snippet.type === SNIPPET_TYPE.OPINIONSTATEMENTS &&
                      'group-odd:bg-[#FFFAE0] group-odd:before:border-r-[#FFFAE0] group-odd:after:border-r-[#FFFAE0] group-odd:hover:bg-[#CCCCCC] group-odd:hover:before:border-r-[#CCCCCC] group-odd:hover:after:border-r-[#CCCCCC]',
                    snippet.type === SNIPPET_TYPE.DUBIOUSCLAIMS &&
                      'group-odd:bg-[#FFE6DE] group-odd:before:border-r-[#FFE6DE] group-odd:after:border-r-[#FFE6DE] group-odd:hover:bg-[#CCCCCC] group-odd:hover:before:border-r-[#CCCCCC] group-odd:hover:after:border-r-[#CCCCCC]',
                  )}
                >
                  <p className="break-words text-xs font-normal leading-[.8125rem] text-neutral-2 @cred-md:text-sm @cred-md:leading-[15.2px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-lg @cred-xl:leading-[21.7px]">
                    {getSnippetTextWithQuotes(snippet.text)}
                  </p>
                  {snippet.source && (
                    <div className="flex w-full justify-end">
                      <div className="text-end">
                        <p className="line-clamp-3 text-[.625rem] font-semibold leading-tight text-neutral-2 @cred-md:text-xs @cred-md:leading-[14px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-base @cred-xl:leading-[19px]">
                          {snippet.source}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </TooltipTrigger>
              <AnalysisTooltipContent className="z-200 max-w-72 rounded-md bg-light-blue px-3 py-2 shadow-[0_.25rem_.75rem_rgba(0,0,0,0.3)] @cred-md:max-w-80 @cred-lg:max-w-[330px] @cred-xl:max-w-[440px]">
                <div className="flex flex-col">
                  <p className="text-[.625rem] font-bold leading-[.8125rem] text-neutral-2 @cred-md:text-xs @cred-md:leading-[14px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-base @cred-xl:leading-[19px]">
                    Reason:
                  </p>
                  <p className="text-[.625rem] font-normal leading-[.8125rem] text-neutral-2 @cred-md:text-xs @cred-md:leading-[14px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-base @cred-xl:leading-[19px]">
                    {snippet.reason}
                  </p>
                </div>
              </AnalysisTooltipContent>
            </Tooltip>
          </TooltipProvider>
          <AccordionContent
            style={{ width: '100%' }} // Needed to fix the width issue
            className="w-full px-[7.5px] pb-0 pt-0.5"
          >
            <div
              className={cn(
                'w-full px-2 py-1.5 rounded-b-[10px]',
                snippet.type === SNIPPET_TYPE.CLAIMEDFACTS &&
                  'group-odd:bg-[#D8FFF2] bg-[#F5F7FA] border-l-[3px] border-l-[#00B378]',
                snippet.type === SNIPPET_TYPE.OPINIONSTATEMENTS &&
                  'group-odd:bg-[#FFFAE0] bg-[#F5F7FA] border-l-[3px] border-l-[#FFD700]',
                snippet.type === SNIPPET_TYPE.DUBIOUSCLAIMS &&
                  'group-odd:bg-[#FEEBE5] bg-[#F5F7FA] border-l-[3px] border-l-[#EA420F]',
              )}
            >
              <p className="text-xs font-normal leading-[.8125rem] text-neutral-2 @cred-md:text-sm @cred-md:leading-[15.2px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-lg @cred-xl:leading-[21.7px]">
                <b className="text-xs font-bold leading-[.8125rem] text-neutral-2 @cred-md:text-sm @cred-md:leading-[15.2px] @cred-lg:text-sm @cred-lg:leading-[16.5px] @cred-xl:text-lg @cred-xl:leading-[21.7px]">
                  Reason:{' '}
                </b>
                {snippet.reason}
              </p>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </MotionDiv>
  );
};
